import React from 'react';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';

const ClientePresupuesto = ({clientes, setClienteSeleccionado, clienteSeleccionado, openModalCliente}) => {
    return (
        <div>
            <p style={{ textAlign:"center", fontSize:"1.3rem" }}>Cliente</p>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Dropdown
                    onChange={(e) => setClienteSeleccionado(e.value)}
                    value={clienteSeleccionado || null}
                    options={clientes}
                    filter
                    showClear
                    filterBy="nombre"
                    placeholder="Seleccione Cliente"
                    optionLabel="nombre"
                    style={{ width:"18rem" }}
                />
                <Button className='ml-2' icon='pi pi-plus' size='small' onClick={() => openModalCliente(true)}/>
            </div>
        </div>

    );
};

export default ClientePresupuesto;
